import cmp from './Verification'

export default cmp
